export const BASE_URL = 'https://torneos-vt.virtualt.org/api/';

